import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0336c710"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sipinor/public_html/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0336c710')) {
      api.createRecord('0336c710', component.options)
    } else {
      api.reload('0336c710', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0336c710", function () {
      api.rerender('0336c710', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/configuration/instance/index.vue"
export default component.exports